module.exports = __webpack_public_path__ + "img/content-img4_1.75ae6179.png";